import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LogIn from "./pages/logIn";
import Home from "./components/home";
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <div className="App">
            <ToastContainer />

      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="logIn" element={<LogIn />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
